import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const icons = {
  dashboard: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
  analytics: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  rentabilidad: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/></svg>,
  costos: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  inventario: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8"/></svg>,
  configuracion: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14"/></svg>,
};

const navItems = [
  { path:'/dashboard', label:'Dashboard', icon:icons.dashboard },
  { path:'/analytics', label:'Analytics', icon:icons.analytics },
  { path:'/rentabilidad', label:'Rentabilidad', icon:icons.rentabilidad },
  { path:'/costos', label:'Costos', icon:icons.costos },
  { path:'/inventario', label:'Inventario', icon:icons.inventario },
  { path:'/configuracion', label:'Configuracion', icon:icons.configuracion },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div style={{display:'grid',gridTemplateColumns:'240px 1fr',minHeight:'100vh',fontFamily:"'Plus Jakarta Sans',sans-serif"}}>
      <aside style={{background:'#fff',borderRight:'1px solid #e8e8e0',display:'flex',flexDirection:'column'}}>
        <div style={{padding:'20px 20px 16px',borderBottom:'1px solid #f0f0e8'}}>
          <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:16}}>
            <div style={{width:34,height:34,borderRadius:10,background:'#d4f542',display:'flex',alignItems:'center',justifyContent:'center'}}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2d4a00" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
            </div>
            <span style={{fontSize:15,fontWeight:800,color:'#1a1a1a',letterSpacing:'-0.3px'}}>NovaEcom</span>
          </div>
          <div style={{background:'#f5f5ef',borderRadius:12,padding:'10px 12px',display:'flex',alignItems:'center',gap:8}}>
            <div style={{width:26,height:26,borderRadius:8,background:'#d4f542',display:'flex',alignItems:'center',justifyContent:'center'}}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#2d4a00" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
            </div>
            <div>
              <div style={{fontSize:9,color:'#bbb',fontWeight:700,textTransform:'uppercase',letterSpacing:'.5px'}}>Tienda activa</div>
              <div style={{fontSize:12,fontWeight:700,color:'#1a1a1a',marginTop:1}}>Colombia ML</div>
            </div>
          </div>
        </div>

        <nav style={{padding:'14px 12px',flex:1}}>
          {navItems.map(item => (
            <NavLink key={item.path} to={item.path}
              style={({isActive}) => ({
                display:'flex',alignItems:'center',gap:10,padding:'10px 12px',borderRadius:12,
                cursor:'pointer',textDecoration:'none',marginBottom:2,fontSize:13,fontWeight:500,transition:'all .15s',
                background:isActive?'#1a1a1a':'transparent',
                color:isActive?'#fff':'#888',
              })}>
              {item.icon}
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div style={{padding:'14px 12px',borderTop:'1px solid #f0f0e8'}}>
          <div style={{background:'linear-gradient(135deg,#7c5ef8,#a855f7)',borderRadius:16,padding:16,position:'relative',overflow:'hidden',marginBottom:12}}>
            <div style={{position:'absolute',top:-20,right:-20,width:70,height:70,background:'rgba(255,255,255,0.1)',borderRadius:'50%'}}></div>
            <div style={{fontSize:26,fontWeight:900,color:'#d4f542',letterSpacing:'-1px',position:'relative',zIndex:1}}>47.6%</div>
            <div style={{fontSize:11,fontWeight:700,color:'#fff',marginTop:2,position:'relative',zIndex:1}}>Margen neto actual</div>
            <div style={{fontSize:10,color:'rgba(255,255,255,0.6)',marginTop:4,lineHeight:1.4,position:'relative',zIndex:1}}>35 productos Winners este mes.</div>
          </div>
          <div style={{display:'flex',alignItems:'center',gap:10,padding:'8px 4px',cursor:'pointer'}} onClick={() => { logout(); navigate('/login'); }}>
            <div style={{width:32,height:32,borderRadius:'50%',background:'linear-gradient(135deg,#7c5ef8,#d4f542)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:800,color:'#fff'}}>
              {user?.name?.charAt(0).toUpperCase()}
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:12,fontWeight:700,color:'#1a1a1a'}}>{user?.name}</div>
              <div style={{fontSize:10,color:'#bbb'}}>Administrador</div>
            </div>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          </div>
        </div>
      </aside>

      <main style={{background:'#f0f0e8',overflow:'auto',display:'flex',flexDirection:'column'}}>
        <Outlet />
      </main>
    </div>
  );
}
